import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';
export default mutatorAction('setBlockCalendarTitle', function setBlockCalendarTitle(title) {
    var optionState = getStore().currentState;
    optionState.blockCalendarTitle = title;
});
//# sourceMappingURL=setBlockCalendarTitle.js.map